import React, { PureComponent } from 'react';

import MapView from '~/kits/general/components/MapView';
import ListView from '~/kits/general/components/ListView';
import Stepper from '~/kits/general/components/Stepper';
import { steps, geojson, data } from '~/kits/general/utils';
import { is768Query } from '~/core/scripts/mediaquery-helper';

const mapHighlightColor = '#4C80BC';

class HandyDataApp extends PureComponent {
  state = {
    currentStep: 0,
    isDesktop: is768Query()
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  onResize = () => {
    const isDesktop = is768Query();

    if (isDesktop === this.setState.isDesktop) {
      return false;
    }

    this.setState({
      isDesktop: is768Query()
    });
  }

  nextStep = () => {
    this.setState({
      currentStep: (this.state.currentStep + 1) % steps.length
    });
  }

  prevStep = () => {
    let nextStep = this.state.currentStep - 1;
    if (nextStep < 0) {
      nextStep = steps.length - 1;
    }

    this.setState({
      currentStep: nextStep
    });
  }

  
  render() {
    const { currentStep, isDesktop } = this.state;

    return (
      <div className="hd-wrapper">
          <div className="hd-content top">
            <MapView geoData={geojson} currentStep={currentStep} highlightColor={mapHighlightColor} />
            {isDesktop && <ListView data={data} currentStep={currentStep} />}
          </div>
          <Stepper
            currentStep={currentStep}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
          />
        {!isDesktop && <ListView data={data} currentStep={currentStep} />}
      </div>
    );
  }
}

export default HandyDataApp;
